//
// keys
//
// key constants, os-specific

export const keyboard = {
    BACKSPACE: 8,
    TAB: 9,
    ENTER: 13,
    // RETURN: 13, // no, just one way to name things
    SHIFT: 16,
    CONTROL: 17,
    ALT: 18,
    ESC: 27,
    SPACE: 32,
    PAGEUP: 33,
    PAGEDOWN: 34,
    END: 35,
    HOME: 36,
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40,
    DEL: 40, // huh? and DOWN?
    KEY_0: 48,
    KEY_1: 49,
    KEY_2: 50,
    KEY_3: 51,
    KEY_4: 52,
    KEY_5: 53,
    KEY_6: 54,
    KEY_7: 55,
    KEY_8: 56,
    KEY_9: 57,
    KEY_A: 65,
    KEY_B: 66,
    KEY_C: 67,
    KEY_D: 68,
    KEY_E: 69,
    KEY_F: 70,
    KEY_G: 71,
    KEY_H: 72,
    KEY_I: 73,
    KEY_J: 74,
    KEY_K: 75,
    KEY_L: 76,
    KEY_M: 77,
    KEY_N: 78,
    KEY_O: 79,
    KEY_P: 80,
    KEY_Q: 81,
    KEY_R: 82,
    KEY_S: 83,
    KEY_T: 84,
    KEY_U: 85,
    KEY_V: 86,
    KEY_W: 87,
    KEY_X: 88,
    KEY_Y: 89,
    KEY_Z: 90,
    COMMAND_LEFT: 91,
    WINDOWS_LEFT: 91,
    WINDOWS_RIGHT: 92,
    COMMAND_RIGHT: 93,
    SELECT: 93, // what's this?
    F1: 112,
    F2: 113,
    F3: 114,
    F4: 115,
    F5: 116,
    F6: 117,
    F7: 118,
    F8: 119,
    F9: 120,
    F10: 121,
    F11: 122,
    F12: 123,
    _: 189,
    test: (event, testKeycode) => {
        const keycode = event.keyCode || event.which
        return keycode === testKeycode
    },
    testCommand: event => {
        // on windows: ctrl-someykey/click, on macos: cmd-someykey/click
        return event.ctrlKey || event.metaKey
    },
    testShift: event => {
        return event.shiftKey
    },
    testAlt: event => {
        return event.altKey
    },
}
